import React, { useState } from 'react';
import { Box, Collapse, Divider, Grid, Typography } from '@material-ui/core';
import { ExpandLess, ExpandMore } from '@material-ui/icons';
import { useTranslation } from 'react-i18next';
import { IVehicle } from '../../reducers/bookings/types';

interface IVehicleFeaturesProps {
  vehicle: IVehicle;
  showInteriorFeatures?: boolean;
  showExteriorFeatures?: boolean;
  showSafetyAndTech?: boolean;
  showOtherFeatures?: boolean;
}

const VehicleFeatures: React.FC<IVehicleFeaturesProps> = ({
  vehicle,
  showInteriorFeatures,
  showExteriorFeatures,
  showSafetyAndTech,
  showOtherFeatures
}) => {
  const { t } = useTranslation();
  const [openSection, setOpenSection] = useState<string | null>(null);

  const handleToggle = (section: string) =>
    setOpenSection(openSection === section ? null : section);

  const featureSections = [
    {
      id: 'interiorFeatures',
      title: t('root:interiorFeatures'),
      data: vehicle.interiorFeatures,
      show: showInteriorFeatures
    },
    {
      id: 'exteriorFeatures',
      title: t('root:exteriorFeatures'),
      data: vehicle.exteriorFeatures,
      show: showExteriorFeatures
    },
    {
      id: 'safetyAndTech',
      title: t('root:safetyAndTechnicalFeatures'),
      data: vehicle.safetyAndTechnicalFeatures,
      show: showSafetyAndTech
    },
    {
      id: 'features',
      title: t('root:otherFeatures'),
      data: vehicle.features,
      show: showOtherFeatures
    }
  ];

  return (
    <Grid item xs={12} container spacing={1}>
      {featureSections.map((section) => {
        const hasData = section.data?.length > 0;

        if (!hasData || !section.show) return null;

        return (
          <Grid item xs={12} key={section.id}>
            <Divider
              style={{
                margin: openSection === section.id ? '12px 0 8px' : '8px 0'
              }}
            />
            <Box
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                cursor: 'pointer',
                padding: '8px 0'
              }}
              onClick={() => handleToggle(section.id)}
            >
              <Typography variant="h4" style={{ fontWeight: 600, fontSize: 16 }}>
                {section.title}
              </Typography>
              {openSection === section.id ? <ExpandLess /> : <ExpandMore />}
            </Box>
            <Collapse in={openSection === section.id}>
              <ul style={{ marginTop: 8, marginBottom: 8, paddingLeft: 20 }}>
                {section.data?.map((item) => (
                  <li key={item} style={{ marginBottom: 6 }}>
                    {item}
                  </li>
                ))}
              </ul>
            </Collapse>
          </Grid>
        );
      })}
    </Grid>
  );
};

export default VehicleFeatures;
